<button
    *ngIf="dataDownloads"
    class="download-all"
    mat-icon-button
    matTooltip="Download all"
    (click)="$event.stopPropagation(); download(dataDownloads)"
    i18n-matTooltip="@@downloadAll"
>
    <mat-icon>save_alt</mat-icon>
</button>
<app-resource-table-base
    #tableBase
    *ngIf="user"
    [matSortActive]="matSortActive"
    [columnsData]="columnsData"
    [columnsKeys]="columnsKeys"
    [expandedRowId]="expandedRowId"
    [expandedFn]="expandedFn"
    (expansionToggled)="expansionToggled($event)"
    [isAllExpanded]="isAllExpanded"
    (moreDataLoaded)="dataDownloads = $event.downloads"
    (expandAllClicked)="onExpandAllClicked($event)"
    (collapseAllClicked)="onCollapseAllClicked()"
    [otherContext]="otherContext"
    [expandingTable]="true"
    [canExpandAll]="true"
    [canSelect]="isCompletedFilter"
    [filter]="filter"
    [tableFilterItems]="tableFilterItems"
    [pageSizeOptions]="pageSizeOptions"
    tableLoaderClass="progress-loader-blue"
    [ngClass]="{ 'user-resource-table': !user.isAdmin() }"
>
    <ng-container tableFiltersTempl>
        <app-table-filter
            [filtersTogglesInOnBtn]="true"
            [defaultFilter]="GlobalFilterProperty.SEARCH"
            [inGlobalFilter]="true"
            color="accent"
            #filter
        >
            <app-table-search
                toggleBtnLabel="Schema"
                i18n-toggleBtnLabel
                [inGlobalFilter]="true"
                class="align-space"
                searchFilterRef
            ></app-table-search>
            <app-table-date-filter [inGlobalFilter]="true" color="accent" dateFilterRef></app-table-date-filter>
            <app-select-filter
                *ngIf="isActivityTab()"
                [inGlobalFilter]="true"
                class="filter-space"
                label="Status"
                i18n-label
                [property]="GlobalFilterProperty.RESOURCS_OCCASION"
                [options]="resourceStatusOptions"
                resStatusFilterRef
            ></app-select-filter>
            <app-select-filter
                [inGlobalFilter]="true"
                class="filter-space"
                label="Type"
                i18n-label="@@type"
                [property]="{
                    name: GlobalFilterProperty.SCOPE,
                    type: GlobalFilterPropertyType.RESOURCE_TYPE
                }"
                [options]="resourceTypeOptions"
                scopesFilterRef
            >
            </app-select-filter>
            <app-tag-chip-search-filter
                [inGlobalFilter]="true"
                fxFlex="50%"
                fxFlex.lt-md="100%"
                fxLayoutAlign="start"
                tagsFilterRef
            ></app-tag-chip-search-filter>
        </app-table-filter>
    </ng-container>
</app-resource-table-base>
<ng-template #multipleSelectionActionsTemplate let-selected>
    <button
        class="download-hover-tools-btn"
        mat-icon-button
        matTooltip="Download selected"
        i18n-matTooltip="@@downloadSelected"
        (click)="$event.stopPropagation(); downloadSelected(selected)"
    >
        <mat-icon>save_alt</mat-icon>
        <span i18n>Download</span>
    </button>
</ng-template>
<ng-template #expansionContextTemplate let-resource>
    <app-instructor-enrollments-occasions-listing
        *ngIf="!!resource.active_occasion_dates?.length && expandedFn(resource)"
        [user]="user"
        [resource]="resource"
        (onUpdateStatus)="onChangeStatus()"
        [filtersToBeApplied]="tableFilterItems"
        (onEnrollMyself)="playFromOccasion($event)"
        class="expansion-context"
    ></app-instructor-enrollments-occasions-listing>
    <app-instructor-enrollments-users-listing
        *ngIf="
            !resource.active_occasion_dates?.length &&
            expandedFn(resource) &&
            !resource.enrollmentRequiredMetadata?.occasion_dates?.length &&
            user.isAdmin()
        "
        [authUser]="user"
        [tableFilterItems]="[
            { property: 'eager', items: ['activations'] },
            { property: 'enrollment_resource', items: [resource.id] }
        ]"
        [resource]="resource"
        (onUpdateStatus)="onChangeStatus()"
        class="expansion-context users"
    ></app-instructor-enrollments-users-listing>
</ng-template>

<ng-template #img let-resource>
    <app-image-view
        *ngIf="!(isMobile$ | async)"
        [media_id]="resource.media$"
        [proportional]="true"
        [paddingBottom]="'58px'"
        [smallSpinner]="true"
        [showImgModalOnClick]="true"
    ></app-image-view>
</ng-template>
<ng-template #title let-resource>
    <ng-container *ngIf="!(isMobile$ | async)">
        <span> {{ resource.title }}</span>
        <div class="hover-wrapper">
            <button
                class="hover-tools-btn view"
                mat-icon-button
                matTooltip="View"
                (click)="$event.stopPropagation(); browse(resource)"
                i18n-matTooltip="@@view"
            >
                <mat-icon>visibility</mat-icon>
            </button>
            <button
                *ngIf="ResourceTypes.isTypeThatHasOccasions(resource.type_id)"
                class="hover-tools-btn view"
                mat-icon-button
                matTooltip="Add Occasion"
                (click)="$event.stopPropagation(); addOccasion(resource)"
                i18n-matTooltip="@@addOccasion"
            >
                <mat-icon>more_time</mat-icon>
            </button>
            <button
                *ngIf="resource.playableResource$ | async as playableResourceCheck"
                [ngStyle]="{ color: $any(playableResourceCheck)?.bg }"
                class="hover-tools-btn view"
                mat-icon-button
                [matTooltip]="$any(playableResourceCheck)?.label"
                (click)="$event.stopPropagation(); !resource.loading && play(resource, playableResourceCheck)"
            >
                <mat-icon>{{ $any(playableResourceCheck)?.icon }}</mat-icon>
            </button>
            <ng-container *ngIf="customer$ | async; let customer">
                <button
                    *ngIf="canEdit(resource, customer)"
                    class="hover-tools-btn view"
                    mat-icon-button
                    matTooltip="Edit"
                    i18n-matTooltip
                    (click)="$event.stopPropagation(); !resource.loading && edit(resource)"
                >
                    <mat-icon class="material-icons-outlined">edit</mat-icon>
                </button>
            </ng-container>
            <ng-container *ngIf="resource.last_publish">
                <button
                    class="hover-tools-btn"
                    *ngIf="!(shareLoading | async); else shareLoadTemp"
                    mat-icon-button
                    matTooltip="Share"
                    i18n-matTooltip="@@share"
                    (click)="$event.stopPropagation(); shareService.openShareDialog(resource, shareLoading)"
                >
                    <mat-icon>share</mat-icon>
                </button>
            </ng-container>
            <button
                *ngIf="resource.downloads"
                class="hover-tools-btn"
                mat-icon-button
                matTooltip="Download PDF"
                i18n-matTooltip="@@downloadPDF"
                (click)="$event.stopPropagation(); download(resource.downloads)"
            >
                <mat-icon>save_alt</mat-icon>
            </button>
            <button
                *ngIf="resource.opportunity_id"
                class="hover-tools-btn"
                mat-icon-button
                matTooltip="Delete"
                (click)="$event.stopPropagation(); deleteCourseFromList(resource)"
                i18n-matTooltip="@@delete"
            >
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </ng-container>
    <ng-container *ngIf="isMobile$ | async">
        <div fxLayout="row" fxLayoutGap="5px" class="w-100" fxLayoutAlign="start start">
            <app-image-view
                [media_id]="resource.media$"
                [proportional]="true"
                [paddingBottom]="'50px'"
                [smallSpinner]="true"
            ></app-image-view>
            <span class="res-title" fxFlex="grow"> {{ resource.title }}</span>
            <div fxLayout="column" fxLayoutAlign="start start">
                <ng-container *ngIf="customer$ | async; let customer">
                    <mat-icon
                        *ngIf="resource | resourceStatus : true as resStatus"
                        (click)="$event.stopPropagation(); onEditCreated(resource, customer)"
                        [ngStyle]="{ color: resStatus.color }"
                    >
                        {{ resStatus.icon }}
                    </mat-icon>
                </ng-container>
                <!-- <mat-icon
                    [ngStyle]="{ color: (resource | resourceCertificate).color }"
                    [ngClass]="{ 'disabled-icon': !resource.downloads }"
                    class="cert-icon"
                >
                    {{ (resource | resourceCertificate).icon }}
                </mat-icon> -->
                <ng-container
                    *ngIf="canExpand(resource) && ResourceTypes.parentType(resource.type_id) != ResourceTypes.EVENT"
                >
                    <button
                        *ngIf="resource.id as expandId"
                        class="mob-expand-btn"
                        (click)="$event.stopPropagation(); expansionToggled(resource)"
                        mat-icon-button
                    >
                        <mat-icon>{{ expandedFn(resource) ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                </ng-container>
            </div>
        </div>
    </ng-container>
</ng-template>
<ng-template #enrollment_period let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@enrollment_period">Enrollment Period: </span>
    <ng-container *ngIf="!!resource.occasion_dates?.length && resource.occasion_dates.length === 1">
        <div *ngIf="!!resource.enrollment_dates" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <span
                *ngIf="!resource.enrollment_dates?.end_date && resource.enrollment_dates?.start_date"
                class="bold-text"
                i18n="@@From"
                >From</span
            >
            <span
                [matTooltip]="resource.enrollment_dates?.application_start_date | kdDateFormat : 'YYYY-MM-DD'"
                class="bold-text"
                *ngIf="resource.enrollment_dates?.application_start_date"
                >{{ resource.enrollment_dates?.application_start_date | kdDateFormat : 'MMM D' }}
            </span>
            <span *ngIf="resource.enrollment_dates?.application_end_date" class="bold-text non-cap" i18n="@@until"
                >until</span
            >
            <!-- <mat-icon *ngIf="resource.enrollment_dates?.application_end_date" class="t0-icon"
                >keyboard_double_arrow_right</mat-icon
            > -->
            <span
                [matTooltip]="resource.enrollment_dates?.application_end_date | kdDateFormat : 'YYYY-MM-DD'"
                class="bold-text"
                *ngIf="resource.enrollment_dates?.application_end_date"
                >{{ resource.enrollment_dates?.application_end_date | kdDateFormat : 'MMM D' }}
            </span>
        </div>
    </ng-container>
    <ng-container *ngIf="!!resource.occasion_dates?.length && resource.occasion_dates.length > 1">
        <span class="multiple-occasions-text" i18n>Multiple Occasions</span>
    </ng-container>
</ng-template>
<ng-template #occasion_period let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@occasion_period">Occasion Period: </span>
    <ng-container *ngIf="!!resource.occasion_dates?.length && resource.occasion_dates.length === 1">
        <div *ngIf="!!resource.enrollment_dates" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <span
                *ngIf="!resource.enrollment_dates?.end_date && resource.enrollment_dates?.start_date"
                class="bold-text"
                i18n="@@From"
                >From</span
            >
            <span
                [matTooltip]="resource.enrollment_dates?.start_date | kdDateFormat : 'YYYY-MM-DD'"
                class="bold-text"
                *ngIf="resource.enrollment_dates?.start_date"
                >{{ resource.enrollment_dates?.start_date | kdDateFormat : 'MMM D' }}
            </span>
            <span *ngIf="resource.enrollment_dates?.end_date" class="bold-text non-cap" i18n="@@until">until</span>
            <span
                [matTooltip]="resource.enrollment_dates?.end_date | kdDateFormat : 'YYYY-MM-DD'"
                class="bold-text"
                *ngIf="resource.enrollment_dates?.end_date"
                >{{ resource.enrollment_dates?.end_date | kdDateFormat : 'MMM D' }}
            </span>
        </div>
    </ng-container>
    <ng-container *ngIf="!!resource.occasion_dates?.length && resource.occasion_dates.length > 1">
        <span class="multiple-occasions-text" i18n>Multiple Occasions</span>
    </ng-container>
</ng-template>
<ng-template #enrollmentCount let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@EnrollmentCount">Enrollment Count: </span>
    <div
        *ngIf="user.isAdmin()"
        class="enrollment-count-wrapper"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="3px"
    >
        <span
            [matTooltip]="getEnrollToolTip(resource.enrollment_counts)"
            matTooltipClass="enrollment-tooltip"
            class="{{ getfirstColor(resource.enrollment_counts) }}"
            >{{ resource.enrollment_counts?.total }}
        </span>
        <div>/</div>
        <span
            [matTooltip]="getTotalSeatsToolTip(resource.enrollment_counts)"
            matTooltipClass="enrollment-tooltip"
            class="{{ getsecondColor(resource.enrollment_counts) }}"
            *ngIf="!!resource.enrollment_counts?.total_seats"
            >{{ resource.enrollment_counts?.total_seats }}
        </span>
        <mat-icon
            matTooltip="Unlimited Seats"
            i18n-matTooltip="@@unlimitedSeats"
            class="dark-blue"
            *ngIf="!resource.enrollment_counts?.total_seats"
            >all_inclusive</mat-icon
        >
    </div>
    <div
        *ngIf="!user.isAdmin()"
        class="enrollment-count-wrapper"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="3px"
    >
        <ng-container *ngIf="!resource.enrollment_counts?.total_seats">
            <mat-icon matTooltip="Unlimited Seats" i18n-matTooltip="@@unlimitedSeats" class="dark-blue"
                >all_inclusive</mat-icon
            >
        </ng-container>
        <ng-container *ngIf="!!resource.enrollment_counts?.total_seats">
            <span
                [matTooltip]="getEnrollToolTip(resource.enrollment_counts)"
                matTooltipClass="enrollment-tooltip"
                class="{{ getfirstColor(resource.enrollment_counts) }}"
                >{{ resource.enrollment_counts?.total }}
            </span>
            <div>/</div>
            <span
                [matTooltip]="getTotalSeatsToolTip(resource.enrollment_counts)"
                matTooltipClass="enrollment-tooltip"
                class="{{ getsecondColor(resource.enrollment_counts) }}"
                >{{ resource.enrollment_counts?.total_seats }}
            </span>
        </ng-container>
    </div>
</ng-template>
<ng-template #tools let-resource>
    <div *ngIf="!(isMobile$ | async)" class="tools-cell-wrapper">
        <div
            *ngIf="resource.playableResource$ | async as playableResourceCheck"
            [ngStyle]="{
                'background-color': $any(playableResourceCheck)?.bg,
                color: $any(playableResourceCheck)?.fg,
                border: $any(playableResourceCheck)?.border
            }"
            mat-raised-button
            (click)="$event.stopPropagation(); play(resource, playableResourceCheck)"
            [matTooltip]="$any(playableResourceCheck)?.desc"
            class="add-enrollment-wrapper me"
        >
            <mat-icon>{{ $any(playableResourceCheck)?.icon }}</mat-icon>
            <span>{{ $any(playableResourceCheck)?.label }}</span>
        </div>
        <button
            *ngIf="canExpand(resource)"
            (click)="$event.stopPropagation(); expansionToggled(resource)"
            matTooltip="View"
            mat-icon-button
            i18n-matTooltip="@@view"
        >
            <mat-icon>{{ expandedFn(resource) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
        <button *ngIf="!canExpand(resource)" (click)="$event.stopPropagation()" mat-icon-button>
            <mat-icon></mat-icon>
        </button>
    </div>
    <div class="w-100" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="isMobile$ | async">
        <button
            class="hover-tools-btn view"
            mat-icon-button
            matTooltip="View"
            (click)="$event.stopPropagation(); browse(resource)"
            i18n-matTooltip="@@view"
        >
            <mat-icon>visibility</mat-icon>
        </button>
        <button
            *ngIf="resource.playableResource$ | async as playableResourceCheck"
            [ngStyle]="{ color: $any(playableResourceCheck)?.bg }"
            class="hover-tools-btn view"
            mat-icon-button
            [matTooltip]="$any(playableResourceCheck)?.label"
            (click)="$event.stopPropagation(); !resource.loading && play(resource, playableResourceCheck)"
        >
            <mat-icon>{{ $any(playableResourceCheck)?.icon }}</mat-icon>
        </button>
        <ng-container *ngIf="resource.last_publish">
            <button
                class="hover-tools-btn"
                *ngIf="!(shareLoading | async); else shareLoadTemp"
                mat-icon-button
                matTooltip="Share"
                i18n-matTooltip="@@share"
                (click)="$event.stopPropagation(); shareService.openShareDialog(resource, shareLoading)"
            >
                <mat-icon>share</mat-icon>
            </button>
        </ng-container>
        <button
            *ngIf="resource.downloads"
            class="hover-tools-btn"
            mat-icon-button
            matTooltip="Download PDF"
            i18n-matTooltip="@@downloadPDF"
            (click)="$event.stopPropagation(); download(resource.downloads)"
        >
            <mat-icon>save_alt</mat-icon>
        </button>

        <button
            *ngIf="!!resource.user_collaboration?.edit?.status"
            (click)="$event.stopPropagation(); edit(resource)"
            mat-icon-button
        >
            <mat-icon>edit</mat-icon>
        </button>
        <button
            *ngIf="canExpand(resource) && ResourceTypes.parentType(resource.type_id) != ResourceTypes.EVENT"
            (click)="$event.stopPropagation(); expansionToggled(resource)"
            mat-icon-button
        >
            <mat-icon>{{ expandedFn(resource) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
    </div>
</ng-template>
<ng-template #shareLoadTemp>
    <app-kd-logo-loading size="small"></app-kd-logo-loading>
</ng-template>
<ng-template #occasionsManager>
    <app-add-occasio-on-the-fly (occasionChange)="onOccasionFormChange($event)"></app-add-occasio-on-the-fly>
</ng-template>
